import React from 'react'
import { RocketLaunchIcon } from "@heroicons/react/24/outline";

const EvaluateButton = ({onEvaluate, isSubmitting = false}) => {
  return (
    <div className="mt-8 flex justify-center">
        <button
          onClick={onEvaluate}
          disabled={isSubmitting}
          className="inline-flex items-center gap-3 px-20 py-3 bg-red-400 hover:bg-red-300 text-white rounded-lg text-sm font-medium shadow disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <RocketLaunchIcon className="w-5 h-5" />
          <span>{isSubmitting ? "Processing..." : "Evaluate Interview"}</span>
        </button>
      </div>
  )
}

export default EvaluateButton
